module.exports = __webpack_public_path__ + "static/media/gold-foil.d79e9d65.jpg";